import { Grid } from "../../core/components/grid";
import { Config } from "../../core/config/config";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { FieldInstance } from "../../core/components/field";
import { ComponentHelper } from "../../core/util/componentHelper";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { TimeTypeEntity, TimeTypeProps, TimeType } from "./timeType";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { MultiSelect } from "../../core/components/multiSelect";
import { data } from "../../../typeinfo/jquery/index";
import { BaseComponentProps } from "../../core/components/baseComponentProps";
import { GridCustomToolBarButton } from "../../core/components/toolBar";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
import ReactDOM from "react-dom";
export default class EditSchemaContent extends React.Component<EditSchemaContentProps, EditSchemaContentState> {
    private gridOptions: kendo.ui.GridOptions;
    private translations: StringKeyDictionary<string>;
    private factory = ComponentHelper.createFactory();
    private iconIds = {
        add: "add",
        remove: "remove",
        create: "create",
        deactivateSign: "deactivateAfterSign",
        activateSign: "activateAfterSign"

    }
    constructor(props: EditSchemaContentProps) {
        super(props)
        this.state = {
            gridData: props.value,
            selectedItem: null
        }
         this.translations = props.context.translations;
        this.initApp();
    }

    private initApp = () => {
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "Displayname",
                    title: this.translations["Standard.Designation"]
                },
                 {
                    field: "AllowAfterSign",
                    title: this.translations["WebSMS.ServiceReport.EditAfterSign"],
                    template: "# if(data.AllowAfterSign == 1) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#"
                }
            ]
        };
    }

    private setGridData = (gridData: TimeTypeEntity[]) => {
        this.setState({ gridData: gridData }, () => {
            this.props.onChange(this.props.field, gridData);
        })
    }

    private createGrid = () => {
        const customButtons: Array<GridCustomToolBarButton> = [
            { autoEnabledOnRecordSelected: false, caption: this.translations["Standard.Add"], enabled: true, iconClass: "k-i-plus", id: this.iconIds.add },
            { autoEnabledOnRecordSelected: true, caption: this.translations["Standard.Entfernen"], enabled: true, iconClass: "k-i-minus", id: this.iconIds.remove },
            { autoEnabledOnRecordSelected: false, caption: this.translations["Standard.Create"], enabled: true, iconClass: "k-i-plus-outline", id: this.iconIds.create }
            
        ];
        if (Helper.hasValue(this.state.selectedItem)) {
            if (this.state.selectedItem.AllowAfterSign) {
                customButtons.push({ autoEnabledOnRecordSelected: true, caption: this.translations["WebSMS.ServiceReport.DeactivateAfterSign"], enabled: true, id: this.iconIds.deactivateSign, iconClass: "k-i-close" })
            } else {
                customButtons.push({ autoEnabledOnRecordSelected: true, caption: this.translations["WebSMS.ServiceReport.ActivateAfterSign"], enabled: true, id: this.iconIds.activateSign, iconClass: "k-i-check" });
            }
        }
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="editTimeTypeContent"
                    customButtons={customButtons}
                    onClickCustomButton={this.onCustomClick}
                    onSelectionChanged={(dataItem) => {
                        if (Helper.hasValue(dataItem)) {
                            this.setState({ selectedItem: dataItem })
                        }
                    }}
                />
            </div>
        );
    }

    private onCustomClick = (id: string, dataItem: any) => {
        switch (id) {
            case this.iconIds.add:
                this.addTimeType();
                break;
            case this.iconIds.remove:
                this.setGridData(this.state.gridData.filter(f => f.Id !== dataItem.Id))
                break;
            case this.iconIds.create:
                this.openSheet();
                break;
            case this.iconIds.activateSign:
                this.changeAllowAfterSign(dataItem.Id, true);
                break;
            case this.iconIds.deactivateSign:
                 this.changeAllowAfterSign(dataItem.Id, false);
                break;
        }
    }
    private changeAllowAfterSign(id: string, value: boolean) {
        
        HTTPService.post("TimeType/ChangeAllowAfterSign", { id: id, value: value }).then(result => {
            let data= JSON.parse(JSON.stringify(this.state.gridData));
            const index = data.findIndex(t => t.Id === id);
            data[index].AllowAfterSign = value;
            this.setGridData(data);
        });
    }
    private addTimeType = () => {
        let dataItems = this.state.gridData;

        let props = this.factory.getDefaultMultiSelectProps();
        props.onChange = (_, __, dataItem) => {
            dataItems = dataItem;
        }
        props.value = this.state.gridData;
        props.field.dataSourceUrl = "TimeType/Find";
        props.field.dataValueField = "Id";
        props.field.dataTextField = "Displayname";
            
        const targetElement = $("<div>");
        $("body").append(targetElement);
        const dialogProps: DialogProps = {
            title: "",
            actions: [
                {
                    label: Config.translations.cancel,
                    action: () => {

                    }
                },
                {
                    label: Config.translations.ok,
                    action: () => {
                        this.setGridData(dataItems);
                    },
                    primary: true
                }
            ],
            afterClose: () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            }
        };
        ReactDOM.render(
            <Dialog {...dialogProps} open={true} title={Helper.getTranslation("WebSMS.ServiceReport.AddTimeType")} width={"800px"} >
                <FieldInstance label={this.translations["Standard.Designation"]}>
                    <MultiSelect {...props}/>
                </FieldInstance>
            </Dialog >, targetElement[0]); 
    }

    private openSheet = async () => {
        let url = "TimeType/GetTimeTypeById";
        url = encodeURI(url);
        let results = await Promise.all([
            HTTPService.get<JsonResultClass<TimeTypeEntity>>(url),
            Helper.getMetaData("timeType")
        ]);
        if (results[0].Code == 0) {
            const props: TimeTypeProps = {
                context: {
                    contextType: "timeType"
                },
                dataSources: null,
                entity: results[0].Data,
                isWindow: false,
                metadata: results[1],
                title: "",
                closeAfterSave: true
            }
            const sheet = General.Sheet.Manager.createSheet();
            sheet.show(() => {
                sheet.mountContent(TimeType, props);
            });
            sheet.bind(SheetEventType.SavedSuccessfully, (data: { entity: TimeTypeEntity }) => {
                this.add(data.entity); 
            });
        } else {
            NotificationHelper.showErrorMessage(results[0].Message);
        }
    }

    private add = (dataItem: TimeTypeEntity) => {
        if (Helper.hasValue(dataItem) && !Helper.hasValue(this.state.gridData.find(f => f.Id == dataItem.Id))) {
            let data = this.state.gridData;
            data.push(dataItem);
            this.setGridData(data);
        }
    }

    render() {
        return this.createGrid();
    }
}

interface EditSchemaContentProps extends BaseComponentProps {
    value:any[];
    context: any;
}

interface EditSchemaContentState{
    gridData: TimeTypeEntity[];
    selectedItem: TimeTypeEntity;
}
